import { render, staticRenderFns } from "./DashUserAvatar.vue?vue&type=template&id=34293253&"
import script from "./DashUserAvatar.vue?vue&type=script&lang=js&"
export * from "./DashUserAvatar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports